import React from 'react';
import {Control} from 'react-hook-form';

import FormGroupWithError from 'shared/ui/FormGroup/FormGroupWithError';
import ChipInput from 'shared/ui/Input/ChipInput/ChipInput';

import {tagsAPI} from '../../api/tagsAPI';

interface ITagsChipFieldProps {
    control: Control<any>,
    label?: string,
    error?: string,
    className?: string,
}

const TagsChipField: React.FC<ITagsChipFieldProps> = ({control, label, error, className}) => {
    const {data: allTags = []} = tagsAPI.useGetTagsQuery();

    return (
        <FormGroupWithError label={label} error={error} className={className}>
            <ChipInput
                name="tags"
                control={control}
                availableOptions={allTags.map(tag => tag.label)}
            />
        </FormGroupWithError>
    );
};

export default TagsChipField;
